var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { autoinject, transient, bindable } from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import * as Enumerable from "linq";
import { ChildComponent } from "../../../../pages/modules/child-component";
import { NotificationClientService, NotificationType } from "../../../../../services/basics/notification-client.service";
import { BrandClientService, LotteryKeyHelper, BundleKeyHelper } from "../../../../../services/modules/brand-client.service";
import { LotteryClientService } from "../../../../../services/modules/lottery-client.service";
import { AttachmentClientService } from "../../../../../services/modules/attachements-client.service";
import { RenderThemeClientService } from "../../../../../services/modules/render-theme-client.service";
import { RenderSectionType, RenderPageType } from "../../../../../models/modules/render-theme.models";
import { RenderColorTokenDefaults } from "../../../../../models/modules/render-color-token-defaults";
import { RenderVariantColorTokens, RenderLobbyPageColorTokens } from "../../../../../models/modules/render-variant-color-tokens";
import { RenderVariantCatalog, findRenderVariant, variantPages, variantVersion, variantColorPrefixes } from "../../../../../models/modules/render-variant-catalog";
import { LookupClientService } from "../../../../../services/lookups/lookup-client.service";
import { resolveBrandCapabilities } from "../../../../../models/modules/render-brand-capabilities";
import { LookupValueRequest, LookupValueQuery } from "../../../../../models/lookups/lookup.models";
var BrandRenderTheme = /** @class */ (function (_super) {
    __extends(BrandRenderTheme, _super);
    function BrandRenderTheme(notificationService, i18N, brandClientService, lotteryClientService, attachmentClientService, renderThemeClientService, lookupClientService) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.brandClientService = brandClientService;
        _this.lotteryClientService = lotteryClientService;
        _this.attachmentClientService = attachmentClientService;
        _this.renderThemeClientService = renderThemeClientService;
        _this.lookupClientService = lookupClientService;
        _this.theme = null;
        _this.templateName = null;
        _this.loading = false;
        _this.saving = false;
        _this.publishing = false;
        // When false the host (combined editor) supplies a shared preview; standalone keeps its own.
        _this.embeddedPreview = true;
        // Host hook: notified with the variant id when a colour group is clicked, so the left panel follows.
        _this.onSelectVariant = null;
        // Item-scoped editor mode (set by the bundle/syndicate render dialog before activation): edits one
        // bundle's/syndicate's override token set. Brand/template come via overrides because the dialog's
        // model is a BundleModel/SyndicateModel.
        _this.bundleId = null;
        _this.syndicateId = null;
        _this.brandLotteryId = null;
        _this.overrideBrandId = null;
        _this.overrideTemplateName = null;
        _this.selectedPageType = RenderPageType.Lobby;
        _this.selectedPage = "lobby";
        // Drives the embedded preview's page tabs when this pane supplies its own picker.
        _this.brandCapabilities = null;
        // Content (text + images) editor state: one language at a time, searchable.
        _this.selectedLang = "en";
        _this.contentSearch = "";
        // Languages this brand supports (from brandLanguages via the languages lookup). Drives the inline-edit
        // language picker so any supported language is selectable even before it has any token data yet.
        _this.contentLanguages = [];
        // "Copy from another item" (item editor only): same-type sources the host dialog fills in, plus the
        // picked source key and an in-flight flag. Copy overlays the source's token set onto this item's;
        // the existing Save then persists it. Empty ⇒ the control is hidden (e.g. the brand-level editor).
        _this.copyCandidates = [];
        _this.copySourceKey = "";
        _this.copyingTokens = false;
        // Which token categories the copy includes. Colours = colour/typography/spacing/radius; Images =
        // image/imageText; Text = text. All on = copy everything.
        _this.copyColors = true;
        _this.copyImages = true;
        _this.copyText = true;
        // This item's name slug (set by the host dialog). Item text/image keys are prefixed with it, so a copy
        // re-prefixes the source's keys onto this one.
        _this.itemKeyPrefix = null;
        // Bulk per-item image editor, shown in the LOTTERY assets dialog (banner/logo per lottery) and the BUNDLE
        // dialog (lobby card background per bundle): the brand's lotteries/bundles (name + slug), the grouped upload
        // slots, and the brand-base token set the slots are stored in (slug-namespaced keys, so each item's page
        // renders its own at runtime). Saved alongside the item save.
        _this.brandLotteries = [];
        _this.brandBundles = [];
        // One entry per image type (lottery Banners/Logos, or bundle Backgrounds); `single` = one unsized image per
        // item vs per-size slots. Named generically because both dialogs share the same render markup.
        _this.itemImageSections = [];
        _this.bannerTheme = null;
        // Host hook: when set (combined editor), placement is read LIVE from the layout panel so adding/
        // removing a section there updates the colour groups here immediately. Unset (standalone) ⇒ own doc.
        _this.layoutSectionsProvider = null;
        _this.colorSections = [];
        _this.imageKeys = [];
        return _this;
    }
    BrandRenderTheme_1 = BrandRenderTheme;
    BrandRenderTheme.prototype.onActivated = function (model) {
        this.brandCapabilities = resolveBrandCapabilities(model);
        this.theme = null;
        this.colorSections = [];
        this.bannerTheme = null;
        this.brandLotteries = [];
        this.brandBundles = [];
        this.itemImageSections = [];
        this.loadContentLanguages(model);
        if (this.bundleId != null) {
            this.selectedPageType = RenderPageType.Bundle;
            this.selectedPage = "bundle";
            this.loadForItem(this.bundleId, null, null);
        }
        else if (this.syndicateId != null) {
            this.selectedPageType = RenderPageType.Syndicate;
            this.selectedPage = "syndicate";
            this.loadForItem(null, this.syndicateId, null);
        }
        else if (this.brandLotteryId != null) {
            this.selectedPageType = RenderPageType.Lottery;
            this.selectedPage = "lottery";
            this.loadForItem(null, null, this.brandLotteryId);
            // The lottery assets dialog also bulk-edits every lottery's banner images (brand-base tokens).
            this.loadBrandLotteries(this.overrideBrandId);
            this.loadBrandBaseImages();
        }
        else if (model && model.brandId) {
            this.load(model);
        }
    };
    BrandRenderTheme.prototype.loadForItem = function (bundleId, syndicateId, brandLotteryId) {
        var _this = this;
        this.loading = true;
        this.templateName = this.overrideTemplateName;
        this.renderThemeClientService.getTheme(this.overrideBrandId, this.templateName, bundleId, syndicateId, brandLotteryId).then(function (theme) {
            _this.theme = _this.normalize(theme);
            _this.loading = false;
        }).catch(function () {
            _this.loading = false;
            _this.notificationService.show(_this.i18N.tr("error"), _this.i18N.tr("render-theme-load-error"), NotificationType.Error);
        });
    };
    BrandRenderTheme.prototype.resolveBrandId = function () {
        if (this.bundleId != null || this.syndicateId != null || this.brandLotteryId != null)
            return this.overrideBrandId;
        return this.item ? this.item.brandId : null;
    };
    BrandRenderTheme.prototype.load = function (brand) {
        var _this = this;
        this.loading = true;
        this.brandClientService.getTemplates().then(function (templates) {
            var template = Enumerable.from(templates).firstOrDefault(function (t) { return t.templateId == brand.templateId; });
            _this.templateName = template ? template.internalName : null;
            _this.renderThemeClientService.getTheme(brand.brandId, _this.templateName).then(function (theme) {
                _this.theme = _this.normalize(theme);
                _this.loading = false;
                // The brand editor bulk-edits every bundle's lobby-card background (stored in this brand-base set).
                _this.loadBrandBundles(brand.brandId);
            }).catch(function () {
                _this.loading = false;
                _this.notificationService.show(_this.i18N.tr("error"), _this.i18N.tr("render-theme-load-error"), NotificationType.Error);
            });
        });
    };
    // The brand's lotteries (name + slug), for the bulk banner editor in the lottery dialog.
    BrandRenderTheme.prototype.loadBrandLotteries = function (brandId) {
        var _this = this;
        if (!brandId)
            return;
        this.lotteryClientService.getLotteriesByBrand(brandId).then(function (lotteries) {
            var seen = {};
            _this.brandLotteries = (lotteries || [])
                .map(function (x) { return (x.lottery && x.lottery.name) || null; })
                .filter(function (n) { return !!n; })
                .map(function (name) { return ({ name: name, slug: LotteryKeyHelper.getKey(name) }); })
                .filter(function (l) { return (seen[l.slug] ? false : (seen[l.slug] = true)); });
            _this.rebuildItemImages();
        }).catch(function () { });
    };
    // The brand's bundles (name + slug), for the bulk lobby-card-background editor in the bundle dialog.
    BrandRenderTheme.prototype.loadBrandBundles = function (brandId) {
        var _this = this;
        if (!brandId)
            return;
        this.lotteryClientService.getBundlesByBrand(brandId).then(function (bundles) {
            var seen = {};
            _this.brandBundles = (bundles || [])
                .map(function (b) { return b.name || null; })
                .filter(function (n) { return !!n; })
                .map(function (name) { return ({ name: name, slug: BundleKeyHelper.getKey(name) }); })
                .filter(function (b) { return (seen[b.slug] ? false : (seen[b.slug] = true)); });
            _this.rebuildItemImages();
            // Bundle keys were just ensured in the token set; refresh the flat Images list so they're excluded.
            if (_this.theme)
                _this.buildContentSections(_this.theme, _this.selectedLang);
        }).catch(function () { });
    };
    // The brand-base token set where the per-lottery banner/logo images live (slug-namespaced, served per-lottery).
    // Lottery dialog only: there the main `theme` is lottery-scoped, so a separate brand-base holder is needed.
    // (Bundle card backgrounds are edited in the BRAND editor, where `theme` already IS the brand-base set.)
    BrandRenderTheme.prototype.loadBrandBaseImages = function () {
        var _this = this;
        if (this.brandLotteryId == null || !this.overrideBrandId)
            return;
        this.renderThemeClientService.getTheme(this.overrideBrandId, this.overrideTemplateName).then(function (base) {
            _this.bannerTheme = _this.ensureTokenDicts(base);
            _this.rebuildItemImages();
        }).catch(function () { });
    };
    Object.defineProperty(BrandRenderTheme.prototype, "isBrandScope", {
        // True in the brand editor (no item scope). The bundle-background bulk editor shows here.
        get: function () {
            return this.bundleId == null && this.syndicateId == null && this.brandLotteryId == null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrandRenderTheme.prototype, "itemImageTheme", {
        // The token set the bulk image slots bind to: the lottery dialog's brand-base holder, else the main theme
        // (which in the brand editor already IS the brand-base set). Only one of the two is ever active at a time.
        get: function () {
            return this.bannerTheme || this.theme;
        },
        enumerable: false,
        configurable: true
    });
    // The current language's image tokens, for the Structure pane's per-item section image slots (they are
    // edited there but stored here, where the runtime reads them). Returns the live dictionary so the
    // uploaders two-way bind straight onto it; null before a theme has loaded.
    BrandRenderTheme.prototype.imageDict = function () {
        var theme = this.itemImageTheme;
        if (!theme || !theme.tokens)
            return null;
        // Read-mostly: this runs on every dirty-check behind the slot getters, so it only assigns when a
        // dictionary is genuinely missing rather than writing the same reference back each time.
        if (!theme.tokens.imageText)
            theme.tokens.imageText = {};
        var lang = this.selectedLang;
        if (!theme.tokens.imageText[lang])
            theme.tokens.imageText[lang] = {};
        return theme.tokens.imageText[lang];
    };
    // Minimal normalize: guarantee token group dicts exist so the banner uploaders can bind.
    BrandRenderTheme.prototype.ensureTokenDicts = function (theme) {
        if (!theme)
            return null;
        theme.tokens = theme.tokens || {};
        theme.tokens.color = theme.tokens.color || {};
        theme.tokens.typography = theme.tokens.typography || {};
        theme.tokens.spacing = theme.tokens.spacing || {};
        theme.tokens.radius = theme.tokens.radius || {};
        theme.tokens.image = theme.tokens.image || {};
        theme.tokens.text = theme.tokens.text || {};
        theme.tokens.imageText = theme.tokens.imageText || {};
        return theme;
    };
    /** Guarantee every group exists so the view can bind/iterate even on an empty preset. */
    BrandRenderTheme.prototype.normalize = function (theme) {
        if (!theme)
            return null;
        theme.tokens = theme.tokens || {};
        theme.tokens.color = theme.tokens.color || {};
        theme.tokens.typography = theme.tokens.typography || {};
        theme.tokens.spacing = theme.tokens.spacing || {};
        theme.tokens.radius = theme.tokens.radius || {};
        theme.tokens.image = theme.tokens.image || {};
        theme.tokens.text = theme.tokens.text || {};
        theme.tokens.imageText = theme.tokens.imageText || {};
        this.backfillColorPalette(theme);
        this.pruneRadiusTokens(theme);
        this.colorSections = this.buildColorSections(theme);
        this.buildContentSections(theme, this.selectedLang);
        return theme;
    };
    /** Copy server-side metadata after a save without rebuilding tokens/colorSections. */
    BrandRenderTheme.prototype.applySavedMeta = function (updated) {
        if (!updated || !this.theme)
            return;
        this.theme.renderThemeId = updated.renderThemeId;
        this.theme.brandId = updated.brandId;
        this.theme.renderTokenSetId = updated.renderTokenSetId;
        this.theme.baseRenderThemeId = updated.baseRenderThemeId;
        this.theme.hasDraftChanges = updated.hasDraftChanges;
        this.theme.name = updated.name;
        this.theme.internalName = updated.internalName;
    };
    // Keys are stored WITHOUT the group prefix - the server emits "--<group>-<key>", so "button" is what
    // renders as --radius-button. "button" is only ever the square override "0"; any other value (and the
    // retired input key, plus the group-prefixed keys an earlier build wrote) is stale editor state.
    BrandRenderTheme.prototype.pruneRadiusTokens = function (theme) {
        var radius = theme.tokens.radius;
        delete radius["input"];
        delete radius["radius-input"];
        delete radius["radius-button"];
        if (radius["button"] !== undefined && radius["button"] !== "0")
            delete radius["button"];
    };
    BrandRenderTheme.prototype.backfillColorPalette = function (theme) {
        var e_1, _a;
        var color = theme.tokens.color;
        try {
            for (var _b = __values(this.surfacedColorKeys(theme)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                if (color[key] === undefined && RenderColorTokenDefaults[key] !== undefined)
                    color[key] = RenderColorTokenDefaults[key];
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    BrandRenderTheme.prototype.surfacedColorKeys = function (theme) {
        var e_2, _a;
        if (this.selectedPageType === RenderPageType.Lobby) {
            var keys_1 = new Set(RenderLobbyPageColorTokens);
            try {
                for (var _b = __values(this.placedVariantIds(theme)), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var id = _c.value;
                    (RenderVariantColorTokens[id] || []).forEach(function (k) { return keys_1.add(k); });
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
            return __spreadArray([], __read(keys_1), false);
        }
        // Non-lobby: page chrome (keys owned by no variant) is always editable; a variant's keys are
        // surfaced only when that variant is actually placed - so removing a section hides its colours.
        var prefix = this.selectedPage + "-";
        var allKeys = Object.keys(RenderColorTokenDefaults).filter(function (k) { return k.indexOf(prefix) === 0; });
        var ownedPrefixes = this.pageVariantColorPrefixes();
        var placedPrefixes = this.placedColorPrefixes(theme);
        return allKeys.filter(function (k) {
            var owner = ownedPrefixes.filter(function (p) { return k.indexOf(p) === 0; })[0];
            return !owner || placedPrefixes.indexOf(owner) >= 0;
        });
    };
    BrandRenderTheme.prototype.pageVariantColorPrefixes = function () {
        var e_3, _a, e_4, _b;
        var prefixes = [];
        try {
            for (var RenderVariantCatalog_1 = __values(RenderVariantCatalog), RenderVariantCatalog_1_1 = RenderVariantCatalog_1.next(); !RenderVariantCatalog_1_1.done; RenderVariantCatalog_1_1 = RenderVariantCatalog_1.next()) {
                var v = RenderVariantCatalog_1_1.value;
                if (variantPages(v).indexOf(this.selectedPageType) < 0)
                    continue;
                try {
                    for (var _c = (e_4 = void 0, __values(variantColorPrefixes(v, this.selectedPageType))), _d = _c.next(); !_d.done; _d = _c.next()) {
                        var p = _d.value;
                        if (prefixes.indexOf(p) < 0)
                            prefixes.push(p);
                    }
                }
                catch (e_4_1) { e_4 = { error: e_4_1 }; }
                finally {
                    try {
                        if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                    }
                    finally { if (e_4) throw e_4.error; }
                }
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (RenderVariantCatalog_1_1 && !RenderVariantCatalog_1_1.done && (_a = RenderVariantCatalog_1.return)) _a.call(RenderVariantCatalog_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return prefixes;
    };
    BrandRenderTheme.prototype.placedColorPrefixes = function (theme) {
        var e_5, _a, e_6, _b;
        var prefixes = [];
        try {
            for (var _c = __values(this.placedVariantIds(theme)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var id = _d.value;
                var v = findRenderVariant(id);
                try {
                    for (var _e = (e_6 = void 0, __values(variantColorPrefixes(v, this.selectedPageType))), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var p = _f.value;
                        if (prefixes.indexOf(p) < 0)
                            prefixes.push(p);
                    }
                }
                catch (e_6_1) { e_6 = { error: e_6_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_6) throw e_6.error; }
                }
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_5) throw e_5.error; }
        }
        return prefixes;
    };
    BrandRenderTheme.prototype.layoutForPage = function (theme) {
        var _this = this;
        return theme && theme.layouts
            ? Enumerable.from(theme.layouts).firstOrDefault(function (l) { return l.pageType === _this.selectedPageType; })
            : null;
    };
    BrandRenderTheme.prototype.currentPageSections = function (theme) {
        if (this.layoutSectionsProvider) {
            var live = this.layoutSectionsProvider();
            if (live)
                return live;
        }
        var doc = this.layoutForPage(theme);
        return doc ? (doc.sections || []) : [];
    };
    BrandRenderTheme.prototype.placedVariantIds = function (theme) {
        var _this = this;
        var ids = [];
        var visit = function (sections) {
            var e_7, _a;
            try {
                for (var _b = __values(sections || []), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var s = _c.value;
                    if (s.visible === false)
                        continue; // hidden in the layout → not editable here
                    if (s.children && s.children.length) {
                        visit(s.children);
                        continue;
                    } // Row container: no colours of its own
                    var id = _this.variantIdOf(s);
                    if (id && ids.indexOf(id) < 0)
                        ids.push(id);
                }
            }
            catch (e_7_1) { e_7 = { error: e_7_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_7) throw e_7.error; }
            }
        };
        visit(this.currentPageSections(theme));
        return ids;
    };
    /** Rebuild the colour groups (+ backfill their default values) from the current placement.
        Called by the host when the layout panel adds/removes a section. */
    BrandRenderTheme.prototype.refreshColorSections = function () {
        if (!this.theme)
            return;
        this.backfillColorPalette(this.theme);
        this.colorSections = this.buildColorSections(this.theme);
        this.buildContentSections(this.theme, this.selectedLang);
    };
    BrandRenderTheme.prototype.variantIdOf = function (section) {
        if (section.variant)
            return section.variant;
        var def = RenderVariantCatalog.filter(function (v) { return v.isDefault && v.type === section.type; })[0];
        return def ? def.id : null;
    };
    Object.defineProperty(BrandRenderTheme.prototype, "isPreset", {
        get: function () {
            return this.theme != null && !this.theme.brandId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrandRenderTheme.prototype, "roundedButtons", {
        // Ports the legacy per-brand "rounded buttons" switch. Absent token = rounded, so each site keeps its
        // own radius (pills 50px, switch-pages 15px, t3 action buttons 3px); "0" squares them all off.
        get: function () {
            var radius = this.theme && this.theme.tokens && this.theme.tokens.radius;
            return !radius || radius["button"] !== "0";
        },
        set: function (value) {
            if (!this.theme)
                return;
            var radius = Object.assign({}, this.theme.tokens.radius);
            if (value)
                delete radius["button"];
            else
                radius["button"] = "0";
            this.theme.tokens.radius = radius;
        },
        enumerable: false,
        configurable: true
    });
    BrandRenderTheme.prototype.ensureSettings = function () {
        if (!this.theme)
            return null;
        if (!this.theme.tokens.settings)
            this.theme.tokens.settings = { externalTerms: {} };
        if (!this.theme.tokens.settings.externalTerms)
            this.theme.tokens.settings.externalTerms = {};
        return this.theme.tokens.settings;
    };
    Object.defineProperty(BrandRenderTheme.prototype, "showTermsAndConditions", {
        get: function () {
            var s = this.theme && this.theme.tokens && this.theme.tokens.settings;
            return !!(s && s.showTermsAndConditions);
        },
        set: function (value) {
            var s = this.ensureSettings();
            if (s)
                s.showTermsAndConditions = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrandRenderTheme.prototype, "externalTermsEnabled", {
        get: function () {
            var s = this.theme && this.theme.tokens && this.theme.tokens.settings;
            return !!(s && s.externalTermsEnabled);
        },
        set: function (value) {
            var s = this.ensureSettings();
            if (s)
                s.externalTermsEnabled = value;
        },
        enumerable: false,
        configurable: true
    });
    BrandRenderTheme.prototype.externalTermsForLang = function () {
        var s = this.ensureSettings();
        if (!s)
            return null;
        if (!s.externalTerms[this.selectedLang])
            s.externalTerms[this.selectedLang] = {};
        return s.externalTerms[this.selectedLang];
    };
    Object.defineProperty(BrandRenderTheme.prototype, "externalTermsUrl", {
        get: function () {
            var s = this.theme && this.theme.tokens && this.theme.tokens.settings;
            var e = s && s.externalTerms && s.externalTerms[this.selectedLang];
            return (e && e.url) || "";
        },
        set: function (value) {
            var e = this.externalTermsForLang();
            if (e)
                e.url = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrandRenderTheme.prototype, "externalTermsName", {
        get: function () {
            var s = this.theme && this.theme.tokens && this.theme.tokens.settings;
            var e = s && s.externalTerms && s.externalTerms[this.selectedLang];
            return (e && e.name) || "";
        },
        set: function (value) {
            var e = this.externalTermsForLang();
            if (e)
                e.name = value;
        },
        enumerable: false,
        configurable: true
    });
    BrandRenderTheme.prototype.buildColorSections = function (theme) {
        var e_8, _a, e_9, _b;
        if (!theme || !theme.tokens || !theme.tokens.color)
            return [];
        var color = theme.tokens.color;
        var sections = [];
        if (this.selectedPageType === RenderPageType.Lobby) {
            var pageKeys_1 = RenderLobbyPageColorTokens.filter(function (k) { return color[k] !== undefined; });
            if (pageKeys_1.length)
                sections.push({ label: this.i18N.tr("render-theme-page-colors"), keys: pageKeys_1, variant: null, isOpen: false });
            try {
                for (var _c = __values(this.placedVariantIds(theme)), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var id = _d.value;
                    var keys = (RenderVariantColorTokens[id] || []).filter(function (k) { return color[k] !== undefined; });
                    if (keys.length)
                        sections.push({ label: this.variantLabel(id), keys: keys, variant: id, isOpen: false });
                }
            }
            catch (e_8_1) { e_8 = { error: e_8_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_8) throw e_8.error; }
            }
            return sections;
        }
        var surfaced = this.surfacedColorKeys(theme).filter(function (k) { return color[k] !== undefined; });
        var ownedPrefixes = this.pageVariantColorPrefixes();
        var _loop_1 = function (id) {
            var variant = findRenderVariant(id);
            var cps = variantColorPrefixes(variant, this_1.selectedPageType);
            if (!cps.length)
                return "continue";
            var keys = surfaced.filter(function (k) { return cps.some(function (p) { return k.indexOf(p) === 0; }); });
            if (keys.length)
                sections.push({ label: this_1.variantLabel(id), keys: keys, variant: id, isOpen: false });
        };
        var this_1 = this;
        try {
            for (var _e = __values(this.placedVariantIds(theme)), _f = _e.next(); !_f.done; _f = _e.next()) {
                var id = _f.value;
                _loop_1(id);
            }
        }
        catch (e_9_1) { e_9 = { error: e_9_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
            }
            finally { if (e_9) throw e_9.error; }
        }
        var pageKeys = surfaced.filter(function (k) { return !ownedPrefixes.some(function (p) { return k.indexOf(p) === 0; }); });
        if (pageKeys.length)
            sections.unshift({ label: this.i18N.tr("render-theme-page-colors"), keys: pageKeys, variant: null, isOpen: false });
        return sections;
    };
    Object.defineProperty(BrandRenderTheme.prototype, "contentLangs", {
        get: function () {
            var e_10, _a, e_11, _b, e_12, _c;
            var set = { en: true };
            try {
                for (var _d = __values(this.contentLanguages), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var l = _e.value;
                    set[l.code] = true;
                }
            }
            catch (e_10_1) { e_10 = { error: e_10_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                }
                finally { if (e_10) throw e_10.error; }
            }
            if (this.theme && this.theme.tokens) {
                try {
                    for (var _f = __values(Object.keys(this.theme.tokens.text || {})), _g = _f.next(); !_g.done; _g = _f.next()) {
                        var l = _g.value;
                        set[l] = true;
                    }
                }
                catch (e_11_1) { e_11 = { error: e_11_1 }; }
                finally {
                    try {
                        if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                    }
                    finally { if (e_11) throw e_11.error; }
                }
                try {
                    for (var _h = __values(Object.keys(this.theme.tokens.imageText || {})), _j = _h.next(); !_j.done; _j = _h.next()) {
                        var l = _j.value;
                        set[l] = true;
                    }
                }
                catch (e_12_1) { e_12 = { error: e_12_1 }; }
                finally {
                    try {
                        if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                    }
                    finally { if (e_12) throw e_12.error; }
                }
            }
            return Object.keys(set);
        },
        enumerable: false,
        configurable: true
    });
    BrandRenderTheme.prototype.brandLanguageIds = function (model) {
        var raw = (model && model.brandLanguages) ||
            (model && model.navigationInfo && model.navigationInfo.brandLanguages) || [];
        return raw.map(function (e) { return (typeof e === "number" ? e : e && e.languageId); }).filter(function (n) { return !!n; });
    };
    BrandRenderTheme.prototype.flagUrl = function (code) {
        return "".concat(__CDN_IMAGES__, "/localization/").concat(code || "default", ".svg");
    };
    // Load the brand's supported languages (with flags) from the languages lookup, filtered to brandLanguages.
    BrandRenderTheme.prototype.loadContentLanguages = function (model) {
        var _this = this;
        var req = new LookupValueRequest();
        req.lookupValueQuery = LookupValueQuery.languages;
        this.lookupClientService.getLookup(req).then(function (res) {
            var all = (res && res.values) || [];
            var ids = _this.brandLanguageIds(model);
            var chosen = all.filter(function (v) { return ids.indexOf(v.id) >= 0; });
            var list = chosen
                .filter(function (v) { return v.additionalData && v.additionalData.code; })
                .map(function (v) { return ({ code: v.additionalData.code, name: v.name, flag: _this.flagUrl(v.additionalData.code) }); });
            // Dedupe by code so a duplicated lookup entry doesn't show the same language twice.
            var seen = {};
            list = list.filter(function (l) { return (seen[l.code] ? false : (seen[l.code] = true)); });
            if (!list.length)
                list = [{ code: "en", name: "English", flag: _this.flagUrl("en") }];
            _this.contentLanguages = list;
            if (!list.some(function (l) { return l.code === _this.selectedLang; }))
                _this.selectedLang = list[0].code;
        }).catch(function () { });
    };
    BrandRenderTheme.prototype.rebuildItemImages = function () {
        var e_13, _a, e_14, _b, e_15, _c;
        this.itemImageSections = [];
        // Lottery dialog -> the brand-base holder; brand editor -> the main (brand-base) theme. Only one active.
        var theme = this.itemImageTheme;
        if (!theme || !theme.tokens)
            return;
        var lang = this.selectedLang;
        theme.tokens.imageText = theme.tokens.imageText || {};
        var dict = Object.assign({}, theme.tokens.imageText[lang]);
        var changed = false;
        var ensure = function (key) {
            if (dict[key] === undefined) {
                dict[key] = "";
                changed = true;
            }
        };
        var sections = [];
        if (this.brandLotteryId != null)
            try {
                for (var _d = __values(BrandRenderTheme_1.LotteryImageTypes), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var type = _e.value;
                    var lotteries = [];
                    try {
                        for (var _f = (e_14 = void 0, __values(this.brandLotteries)), _g = _f.next(); !_g.done; _g = _f.next()) {
                            var lot = _g.value;
                            var items = [];
                            if (type.sizes) {
                                try {
                                    for (var _h = (e_15 = void 0, __values(type.sizes)), _j = _h.next(); !_j.done; _j = _h.next()) {
                                        var sz = _j.value;
                                        var key = lot.slug + "-" + type.stem + "-" + sz.size;
                                        ensure(key);
                                        items.push({ key: key, label: this.i18N.tr(sz.label) });
                                    }
                                }
                                catch (e_15_1) { e_15 = { error: e_15_1 }; }
                                finally {
                                    try {
                                        if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                                    }
                                    finally { if (e_15) throw e_15.error; }
                                }
                            }
                            else {
                                var key = lot.slug + "-" + type.stem;
                                ensure(key);
                                items.push({ key: key, label: lot.name });
                            }
                            lotteries.push({ label: lot.name, items: items });
                        }
                    }
                    catch (e_14_1) { e_14 = { error: e_14_1 }; }
                    finally {
                        try {
                            if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                        }
                        finally { if (e_14) throw e_14.error; }
                    }
                    sections.push({ label: this.i18N.tr(type.label), single: !type.sizes, lotteries: lotteries });
                }
            }
            catch (e_13_1) { e_13 = { error: e_13_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                }
                finally { if (e_13) throw e_13.error; }
            }
        // Brand editor: one "Bundle Backgrounds" section, a single lobby-card-background slot per bundle.
        if (this.isBrandScope && this.brandBundles.length) {
            var bundles = this.brandBundles.map(function (b) {
                var key = b.slug + "-lobby-card-background";
                ensure(key);
                return { label: b.name, items: [{ key: key, label: b.name }] };
            });
            sections.push({ label: this.i18N.tr("render-bundle-images"), single: true, lotteries: bundles });
        }
        if (changed)
            theme.tokens.imageText[lang] = dict;
        this.itemImageSections = sections;
    };
    // Builds the Images list for the selected language (text is edited inline in the preview, not here).
    BrandRenderTheme.prototype.buildContentSections = function (theme, lang) {
        var e_16, _a, e_17, _b, e_18, _c;
        var _this = this;
        this.imageKeys = [];
        if (!theme || !theme.tokens)
            return;
        var image = (theme.tokens.imageText && theme.tokens.imageText[lang]) || {};
        var q = (this.contentSearch || "").trim().toLowerCase();
        // The bundle-background keys have their own "Bundle Backgrounds" subsection, so keep them out of the flat list.
        var managed = this.isBrandScope ? this.bundleImageKeySet() : {};
        // The brand editor's flat list is for WHOLE-THEME images only (the template background and the
        // page-level advert slots). Anything belonging to a lottery, bundle, scratch card or instant game
        // is edited where that item lives - its own dialog, or its section's modal - so it is not listed
        // here. An allowlist rather than a blocklist: a brand's token set is forked whole from the base
        // theme, so it also carries keys for items this brand does not even have.
        var keep = function (k) { return (!q || k.toLowerCase().indexOf(q) >= 0)
            && !managed[k]
            && !(_this.isBrandScope && !BrandRenderTheme_1.isWholeThemeImageKey(k)); };
        var keys = Object.keys(image).filter(keep);
        if (this.isBrandScope) {
            var offer = function (k) {
                if (keys.indexOf(k) < 0 && keep(k))
                    keys.push(k);
            };
            try {
                for (var _d = __values(BrandRenderTheme_1.AlwaysOfferedImageKeys), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var k = _e.value;
                    offer(k);
                }
            }
            catch (e_16_1) { e_16 = { error: e_16_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                }
                finally { if (e_16) throw e_16.error; }
            }
            try {
                // An image present in one device size gets a slot for the others too: a size with no key yet
                // has no input, and without an input there is no way to upload it in the first place.
                for (var _f = __values(keys.slice()), _g = _f.next(); !_g.done; _g = _f.next()) {
                    var k = _g.value;
                    try {
                        for (var _h = (e_18 = void 0, __values(BrandRenderTheme_1.ItemImageSizes)), _j = _h.next(); !_j.done; _j = _h.next()) {
                            var size = _j.value;
                            var stem = BrandRenderTheme_1.imageKeyStem(k);
                            if (stem)
                                offer(stem + "-" + size.size);
                        }
                    }
                    catch (e_18_1) { e_18 = { error: e_18_1 }; }
                    finally {
                        try {
                            if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                        }
                        finally { if (e_18) throw e_18.error; }
                    }
                }
            }
            catch (e_17_1) { e_17 = { error: e_17_1 }; }
            finally {
                try {
                    if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
                }
                finally { if (e_17) throw e_17.error; }
            }
        }
        // Page background first: it is the one image every page uses, and alphabetical order would bury it.
        var isBackground = function (k) { return BrandRenderTheme_1.AlwaysOfferedImageKeys.indexOf(k) >= 0; };
        this.imageKeys = keys.sort(function (a, b) {
            return (isBackground(b) ? 1 : 0) - (isBackground(a) ? 1 : 0) || a.localeCompare(b);
        });
    };
    BrandRenderTheme.isWholeThemeImageKey = function (key) {
        return BrandRenderTheme_1.WholeThemeImagePrefixes.some(function (p) { return key.indexOf(p) === 0; });
    };
    // The key without its trailing device size, or null when it does not end in one.
    BrandRenderTheme.imageKeyStem = function (key) {
        var e_19, _a;
        try {
            for (var _b = __values(BrandRenderTheme_1.ItemImageSizes), _c = _b.next(); !_c.done; _c = _b.next()) {
                var size = _c.value;
                var suffix = "-" + size.size;
                if (key.length > suffix.length && key.indexOf(suffix, key.length - suffix.length) >= 0)
                    return key.substring(0, key.length - suffix.length);
            }
        }
        catch (e_19_1) { e_19 = { error: e_19_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_19) throw e_19.error; }
        }
        return null;
    };
    BrandRenderTheme.prototype.onContentFilterChanged = function () {
        if (this.theme)
            this.buildContentSections(this.theme, this.selectedLang);
        this.rebuildItemImages();
    };
    BrandRenderTheme.prototype.removeImageText = function (lang, key) {
        var image = Object.assign({}, this.theme.tokens.imageText);
        var langDict = Object.assign({}, image[lang]);
        delete langDict[key];
        image[lang] = langDict;
        this.theme.tokens.imageText = image;
        this.onContentFilterChanged();
    };
    BrandRenderTheme.prototype.selectVariant = function (variantId) {
        if (!variantId)
            return;
        if (this.onSelectVariant)
            this.onSelectVariant(variantId);
        else if (this.preview)
            this.preview.highlightVariant(variantId);
    };
    BrandRenderTheme.prototype.openColorSection = function (section) {
        var e_20, _a;
        if (!section)
            return;
        if (!this.colorSections.length)
            return;
        var id = this.variantIdOf(section);
        var match = this.colorSections.filter(function (s) { return s.variant === id; })[0];
        if (!match)
            return;
        try {
            for (var _b = __values(this.colorSections), _c = _b.next(); !_c.done; _c = _b.next()) {
                var s = _c.value;
                s.isOpen = s === match;
            }
        }
        catch (e_20_1) { e_20 = { error: e_20_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_20) throw e_20.error; }
        }
    };
    BrandRenderTheme.prototype.onPreviewPageChanged = function (page) {
        var type = BrandRenderTheme_1.PageTypeByName[page];
        if (type == null || type === this.selectedPageType)
            return;
        this.selectedPageType = type;
        this.selectedPage = page;
        if (this.theme) {
            this.backfillColorPalette(this.theme);
            this.colorSections = this.buildColorSections(this.theme);
            this.buildContentSections(this.theme, this.selectedLang);
        }
    };
    BrandRenderTheme.prototype.variantLabel = function (id) {
        var v = findRenderVariant(id);
        if (!v)
            return id;
        return this.i18N.tr("render-section-" + RenderSectionType[v.type]) + " - V" + variantVersion(v);
    };
    BrandRenderTheme.prototype.applyInlineText = function (key, value) {
        if (!key || !this.theme)
            return;
        var text = Object.assign({}, this.theme.tokens.text);
        var langDict = Object.assign({}, text[this.selectedLang]);
        langDict[key] = value;
        text[this.selectedLang] = langDict;
        this.theme.tokens.text = text;
        this.onContentFilterChanged();
    };
    Object.defineProperty(BrandRenderTheme.prototype, "isItemScope", {
        // True in a per-item dialog (bundle/syndicate/lottery); the copy panel shows only there, never in the
        // brand-level editor where there is no sibling concept.
        get: function () {
            return this.bundleId != null || this.syndicateId != null || this.brandLotteryId != null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrandRenderTheme.prototype, "canCopyTokens", {
        get: function () {
            return !!(this.theme && this.copyCandidates && this.copyCandidates.length);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(BrandRenderTheme.prototype, "copyHasCategory", {
        get: function () {
            return this.copyColors || this.copyImages || this.copyText;
        },
        enumerable: false,
        configurable: true
    });
    BrandRenderTheme.prototype.copyFromSource = function () {
        var _this = this;
        if (this.copyingTokens || !this.theme || !this.copySourceKey)
            return;
        var src = this.copyCandidates.filter(function (c) { return c.key === _this.copySourceKey; })[0];
        if (!src)
            return;
        this.copyingTokens = true;
        this.renderThemeClientService.getTheme(this.resolveBrandId(), this.templateName, src.bundleId, src.syndicateId, src.brandLotteryId).then(function (sourceTheme) {
            var tokens = sourceTheme && sourceTheme.tokens;
            if (!tokens || _this.isEmptyTokens(tokens)) {
                _this.copyingTokens = false;
                _this.notificationService.show(_this.i18N.tr("render-copy-tokens"), _this.i18N.tr("render-copy-tokens-empty"), NotificationType.Warning);
                return;
            }
            _this.mergeTokens(tokens, src.keyPrefix, { colors: _this.copyColors, images: _this.copyImages, text: _this.copyText });
            _this.refreshColorSections();
            _this.copyingTokens = false;
            // Persist immediately so the copy shows in the preview without a separate Save click.
            _this.save();
        }).catch(function () {
            _this.copyingTokens = false;
            _this.notificationService.show(_this.i18N.tr("error"), _this.i18N.tr("render-copy-tokens-error"), NotificationType.Error);
        });
    };
    BrandRenderTheme.prototype.mergeTokens = function (src, srcPrefix, opts) {
        var dst = this.theme.tokens;
        if (opts.colors) {
            dst.color = Object.assign({}, dst.color, src.color || {});
            dst.typography = Object.assign({}, dst.typography, src.typography || {});
            dst.spacing = Object.assign({}, dst.spacing, src.spacing || {});
            dst.radius = Object.assign({}, dst.radius, src.radius || {});
        }
        if (opts.images) {
            dst.image = Object.assign({}, dst.image, src.image || {});
            dst.imageText = this.mergeItemLangDict(dst.imageText, src.imageText, srcPrefix);
        }
        if (opts.text)
            dst.text = this.mergeItemLangDict(dst.text, src.text, srcPrefix);
    };
    BrandRenderTheme.prototype.mergeItemLangDict = function (dst, src, srcPrefix) {
        var e_21, _a, e_22, _b;
        var out = Object.assign({}, dst);
        try {
            for (var _c = __values(Object.keys(src || {})), _d = _c.next(); !_d.done; _d = _c.next()) {
                var lang = _d.value;
                var merged = Object.assign({}, out[lang]);
                var srcDict = src[lang] || {};
                try {
                    for (var _e = (e_22 = void 0, __values(Object.keys(srcDict))), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var key = _f.value;
                        merged[this.rekeyItemKey(key, srcPrefix)] = srcDict[key];
                    }
                }
                catch (e_22_1) { e_22 = { error: e_22_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_22) throw e_22.error; }
                }
                out[lang] = merged;
            }
        }
        catch (e_21_1) { e_21 = { error: e_21_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_21) throw e_21.error; }
        }
        return out;
    };
    BrandRenderTheme.prototype.rekeyItemKey = function (key, srcPrefix) {
        var dstPrefix = this.itemKeyPrefix;
        if (!srcPrefix || !dstPrefix || srcPrefix === dstPrefix)
            return key;
        if (key === srcPrefix || key.indexOf(srcPrefix + "-") === 0)
            return dstPrefix + key.substring(srcPrefix.length);
        return key;
    };
    BrandRenderTheme.prototype.isEmptyTokens = function (t) {
        var e_23, _a, e_24, _b, e_25, _c;
        try {
            for (var _d = __values(["color", "typography", "spacing", "radius", "image"]), _e = _d.next(); !_e.done; _e = _d.next()) {
                var g = _e.value;
                if (t[g] && Object.keys(t[g]).length)
                    return false;
            }
        }
        catch (e_23_1) { e_23 = { error: e_23_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            }
            finally { if (e_23) throw e_23.error; }
        }
        try {
            for (var _f = __values([t.text, t.imageText]), _g = _f.next(); !_g.done; _g = _f.next()) {
                var d = _g.value;
                try {
                    for (var _h = (e_25 = void 0, __values(Object.keys(d || {}))), _j = _h.next(); !_j.done; _j = _h.next()) {
                        var lang = _j.value;
                        if (Object.keys(d[lang] || {}).length)
                            return false;
                    }
                }
                catch (e_25_1) { e_25 = { error: e_25_1 }; }
                finally {
                    try {
                        if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
                    }
                    finally { if (e_25) throw e_25.error; }
                }
            }
        }
        catch (e_24_1) { e_24 = { error: e_24_1 }; }
        finally {
            try {
                if (_g && !_g.done && (_b = _f.return)) _b.call(_f);
            }
            finally { if (e_24) throw e_24.error; }
        }
        return true;
    };
    BrandRenderTheme.prototype.save = function () {
        var _this = this;
        if (!this.theme || this.saving)
            return;
        this.saving = true;
        this.uploadImages().then(function () {
            return _this.renderThemeClientService.saveTokens({
                renderThemeId: _this.theme.renderThemeId,
                brandId: _this.resolveBrandId(),
                bundleId: _this.bundleId,
                syndicateId: _this.syndicateId,
                brandLotteryId: _this.brandLotteryId,
                name: null,
                tokens: _this.tokensForSave()
            });
        }).then(function (updated) {
            _this.applySavedMeta(updated);
            return _this.saveBrandBaseImages();
        }).then(function () {
            _this.saving = false;
            if (_this.preview)
                _this.preview.reload(true);
            _this.notificationService.show(_this.i18N.tr("success"), _this.i18N.tr("render-theme-save-success"), NotificationType.Success);
        }).catch(function () {
            _this.saving = false;
            _this.notificationService.show(_this.i18N.tr("error"), _this.i18N.tr("render-theme-save-error"), NotificationType.Error);
        });
    };
    BrandRenderTheme.prototype.saveBrandBaseImages = function () {
        var _this = this;
        if (!this.bannerTheme)
            return Promise.resolve();
        return this.uploadImages(this.bannerTheme.tokens).then(function () {
            return _this.renderThemeClientService.saveTokens({
                renderThemeId: _this.bannerTheme.renderThemeId,
                brandId: _this.resolveBrandId(),
                name: null,
                tokens: _this.tokensWithoutEmptyImages(_this.bannerTheme.tokens)
            });
        });
    };
    BrandRenderTheme.prototype.tokensWithoutEmptyImages = function (tokens) {
        var e_26, _a;
        var clone = JSON.parse(JSON.stringify(tokens));
        var strip = function (d) {
            var e_27, _a;
            try {
                for (var _b = __values(Object.keys(d || {})), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var k = _c.value;
                    if (!d[k])
                        delete d[k];
                }
            }
            catch (e_27_1) { e_27 = { error: e_27_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_27) throw e_27.error; }
            }
        };
        strip(clone.image);
        try {
            for (var _b = __values(Object.keys(clone.imageText || {})), _c = _b.next(); !_c.done; _c = _b.next()) {
                var lang = _c.value;
                strip(clone.imageText[lang]);
            }
        }
        catch (e_26_1) { e_26 = { error: e_26_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_26) throw e_26.error; }
        }
        return clone;
    };
    // The bundle-background keys the brand editor manages (`<slug>-lobby-card-background`).
    BrandRenderTheme.prototype.bundleImageKeySet = function () {
        var e_28, _a;
        var set = {};
        try {
            for (var _b = __values(this.brandBundles), _c = _b.next(); !_c.done; _c = _b.next()) {
                var b = _c.value;
                set[b.slug + "-lobby-card-background"] = true;
            }
        }
        catch (e_28_1) { e_28 = { error: e_28_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_28) throw e_28.error; }
        }
        return set;
    };
    BrandRenderTheme.prototype.tokensForSave = function () {
        var e_29, _a, e_30, _b;
        if (!this.isBrandScope || !this.brandBundles.length)
            return this.theme.tokens;
        var managed = this.bundleImageKeySet();
        var clone = JSON.parse(JSON.stringify(this.theme.tokens));
        try {
            for (var _c = __values(Object.keys(clone.imageText || {})), _d = _c.next(); !_d.done; _d = _c.next()) {
                var lang = _d.value;
                try {
                    for (var _e = (e_30 = void 0, __values(Object.keys(clone.imageText[lang]))), _f = _e.next(); !_f.done; _f = _e.next()) {
                        var k = _f.value;
                        if (managed[k] && !clone.imageText[lang][k])
                            delete clone.imageText[lang][k];
                    }
                }
                catch (e_30_1) { e_30 = { error: e_30_1 }; }
                finally {
                    try {
                        if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                    }
                    finally { if (e_30) throw e_30.error; }
                }
            }
        }
        catch (e_29_1) { e_29 = { error: e_29_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_29) throw e_29.error; }
        }
        return clone;
    };
    Object.defineProperty(BrandRenderTheme.prototype, "hasDraftChanges", {
        get: function () {
            return !!(this.theme && this.theme.hasDraftChanges);
        },
        enumerable: false,
        configurable: true
    });
    BrandRenderTheme.prototype.publish = function () {
        var _this = this;
        if (!this.theme || this.publishing || this.saving)
            return;
        this.publishing = true;
        this.renderThemeClientService.publish(this.theme.renderThemeId, this.bundleId, this.syndicateId, this.brandLotteryId).then(function (updated) {
            _this.theme = _this.normalize(updated);
            _this.publishing = false;
            if (_this.preview)
                _this.preview.reload(true);
            _this.notificationService.show(_this.i18N.tr("success"), _this.i18N.tr("render-publish-success"), NotificationType.Success);
        }).catch(function () {
            _this.publishing = false;
            _this.notificationService.show(_this.i18N.tr("error"), _this.i18N.tr("render-publish-error"), NotificationType.Error);
        });
    };
    BrandRenderTheme.prototype.discardDraft = function () {
        var _this = this;
        if (!this.theme || this.publishing || this.saving)
            return;
        this.publishing = true;
        this.renderThemeClientService.discardDraft(this.theme.renderThemeId, this.bundleId, this.syndicateId, this.brandLotteryId).then(function (updated) {
            _this.theme = _this.normalize(updated);
            return _this.discardBrandBaseImageDraft();
        }).then(function () {
            _this.publishing = false;
            if (_this.preview)
                _this.preview.reload(true);
            _this.notificationService.show(_this.i18N.tr("success"), _this.i18N.tr("render-discard-success"), NotificationType.Success);
        }).catch(function () {
            _this.publishing = false;
            _this.notificationService.show(_this.i18N.tr("error"), _this.i18N.tr("render-discard-error"), NotificationType.Error);
        });
    };
    BrandRenderTheme.prototype.discardBrandBaseImageDraft = function () {
        var _this = this;
        if (!this.bannerTheme)
            return Promise.resolve();
        return this.renderThemeClientService.discardDraft(this.bannerTheme.renderThemeId).then(function (base) {
            _this.bannerTheme = _this.ensureTokenDicts(base);
            _this.rebuildItemImages();
        });
    };
    BrandRenderTheme.prototype.uploadImages = function (tokens) {
        var e_31, _a;
        if (tokens === void 0) { tokens = this.theme.tokens; }
        // Collect data: URIs from both the flat image group and every per-language imageText dict.
        var dicts = [tokens.image || {}];
        var imageText = tokens.imageText || {};
        try {
            for (var _b = __values(Object.keys(imageText)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var lang = _c.value;
                dicts.push(imageText[lang]);
            }
        }
        catch (e_31_1) { e_31 = { error: e_31_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_31) throw e_31.error; }
        }
        var dataUris = Enumerable.from(dicts)
            .selectMany(function (d) { return Object.keys(d).map(function (k) { return d[k]; }); })
            .where(function (v) { return !!v && v.indexOf("data:") === 0; })
            .distinct()
            .toArray();
        if (dataUris.length === 0)
            return Promise.resolve();
        return this.attachmentClientService.addAttachments({ dataUris: dataUris, files: null }).then(function (response) {
            var e_32, _a, e_33, _b;
            try {
                for (var dicts_1 = __values(dicts), dicts_1_1 = dicts_1.next(); !dicts_1_1.done; dicts_1_1 = dicts_1.next()) {
                    var dict = dicts_1_1.value;
                    var _loop_2 = function (k) {
                        var v = dict[k];
                        if (v && v.indexOf("data:") === 0) {
                            var match = Enumerable.from(response.attachments).firstOrDefault(function (a) { return a.dataUri === v; });
                            dict[k] = match ? match.newName : "";
                        }
                    };
                    try {
                        for (var _c = (e_33 = void 0, __values(Object.keys(dict))), _d = _c.next(); !_d.done; _d = _c.next()) {
                            var k = _d.value;
                            _loop_2(k);
                        }
                    }
                    catch (e_33_1) { e_33 = { error: e_33_1 }; }
                    finally {
                        try {
                            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                        }
                        finally { if (e_33) throw e_33.error; }
                    }
                }
            }
            catch (e_32_1) { e_32 = { error: e_32_1 }; }
            finally {
                try {
                    if (dicts_1_1 && !dicts_1_1.done && (_a = dicts_1.return)) _a.call(dicts_1);
                }
                finally { if (e_32) throw e_32.error; }
            }
        });
    };
    var BrandRenderTheme_1;
    BrandRenderTheme.PageTypeByName = {
        lobby: RenderPageType.Lobby, lottery: RenderPageType.Lottery, cart: RenderPageType.Cart,
        results: RenderPageType.Results, purchases: RenderPageType.Purchases,
        bundle: RenderPageType.Bundle, syndicate: RenderPageType.Syndicate,
        lotteries: RenderPageType.Lotteries, bundles: RenderPageType.Bundles
    };
    // Device suffixes for per-lottery image tokens (match base-template `size`: lg/sm/xs), with UI labels.
    BrandRenderTheme.ItemImageSizes = [
        { size: "lg", label: "render-image-desktop" },
        { size: "sm", label: "render-image-tablet" },
        { size: "xs", label: "render-image-mobile" }
    ];
    BrandRenderTheme.LotteryImageTypes = [
        { label: "render-lottery-images-banners", stem: "top-banner", sizes: BrandRenderTheme_1.ItemImageSizes },
        { label: "render-lottery-images-logos", stem: "logo", sizes: null }
    ];
    // Prefixes of images that belong to the theme as a whole rather than to one lottery/bundle/game.
    BrandRenderTheme.WholeThemeImagePrefixes = ["template-", "image-"];
    // The page background, read by every page as `template-background-<size>`. It belongs to no section,
    // so the flat list is the only place it can be set - always offer a slot, even on a brand whose token
    // set has no key for it yet (the uploader creates the key on write).
    BrandRenderTheme.AlwaysOfferedImageKeys = BrandRenderTheme_1.ItemImageSizes
        .map(function (s) { return "template-background-" + s.size; });
    __decorate([
        bindable,
        __metadata("design:type", Boolean)
    ], BrandRenderTheme.prototype, "embeddedPreview", void 0);
    BrandRenderTheme = BrandRenderTheme_1 = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [NotificationClientService,
            I18N,
            BrandClientService,
            LotteryClientService,
            AttachmentClientService,
            RenderThemeClientService,
            LookupClientService])
    ], BrandRenderTheme);
    return BrandRenderTheme;
}(ChildComponent));
export { BrandRenderTheme };
